import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { handleEvent } from "util/user-events";

interface DesignState {
    useNewDesign: "default" | "legacy" | "new";
    theme: "light" | "dark" | "system";
    sidebarMode: "default" | "hamburgler" | "compact";
    compactSidebarState: "expanded" | "collapsed";
}
const initialState: DesignState = {
    useNewDesign: "default",
    theme: "light",
    sidebarMode: "default",
    compactSidebarState: "expanded",
};

export const designSlice = createSlice({
    name: "design",
    initialState,
    reducers: {
        setPreviewDesign: (
            state,
            action: PayloadAction<"default" | "legacy" | "new">,
        ) => {
            state.useNewDesign = action.payload;
            setTimeout(() => {
                handleEvent("user-preview-design-toggle", {
                    design: action.payload,
                });
            }, 0);
        },
        setTheme: (state, action: PayloadAction<"light" | "dark" | "system">) => {
            state.theme = action.payload;
        },
        setSidebarMode: (
            state,
            action: PayloadAction<"default" | "hamburgler" | "compact">,
        ) => {
            state.sidebarMode = action.payload;
        },
        setCompactSidebarState: (
            state,
            action: PayloadAction<"expanded" | "collapsed">,
        ) => {
            state.compactSidebarState = action.payload;
        },
    },
});
